import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { clientApi } from "./lib/api";
import { useClientAuth } from "./lib/auth";

export default function ClientAuthCallback() {
  const nav = useNavigate();
  const { setUser } = useClientAuth();

  useEffect(() => {
    (async () => {
      const hash = window.location.hash || "";
      const params = new URLSearchParams(hash.replace(/^#/, ""));
      const sid = params.get("session_id");
      if (!sid) { nav("/cliente/login", { replace: true }); return; }
      try {
        const { data } = await clientApi.post("/auth/google", { session_id: sid });
        setUser(data.user);
        nav("/cliente", { replace: true });
      } catch (e) {
        nav("/cliente/login?error=google", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen theme-dark flex items-center justify-center text-neutral-400 text-sm">
      Finalizando login…
    </div>
  );
}
